import React from 'react';
import { renderFaq } from './shared/renderers';

export default function FaqBlock({ props = {}, theme }) {
  return renderFaq(props, theme);
}
